import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiFileText, FiMail, FiUser, FiBriefcase } = FiIcons;

const WhitepaperSection = () => {
    useEffect(() => {
    // SEO: Add structured data for this section
    const sectionData = {
      "@context": "https://schema.org", "@type": "WebPageElement", "name": "Whitepaper Download", "mainContentOfPage": {
        "@type": "Article", "headline": "The Definitive Enterprise AI Privacy & Security Whitepaper", "author": {"@type": "Organization", "name": "Secure Enterprise AI Solutions"}
      }
    };
    
    const scriptId = 'whitepaper-structured-data';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(sectionData);
  }, []);

  const [formData, setFormData] = useState({ name: '', email: '', company: '' });
  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => { e.preventDefault(); console.log('Form submitted:', formData); };

  return (
    <section id="whitepaper" className="py-20 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800" itemScope itemType="https://schema.org/WebPageElement">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-6" itemProp="headline">Download the Definitive Enterprise AI Privacy & Security Whitepaper</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" itemProp="description">Discover why public AI systems put your organization at risk and how to eliminate exposure—backed by real case findings.</p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">What You'll Learn:</h3>
            <ul className="space-y-3 text-gray-300">
              {["Real-world case studies of AI security breaches", "Regulatory compliance frameworks (GDPR, HIPAA)", "Cost analysis: Public AI vs. Private deployment", "Implementation roadmap for secure AI adoption", "Risk assessment checklist for CTOs and CISOs"].map((item, index) => (
                <li key={index} className="flex items-start"><SafeIcon icon={FiFileText} className="text-teal-400 mt-1 mr-3 flex-shrink-0" />{item}</li>
              ))}
            </ul>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, delay: 0.2 }} viewport={{ once: true }} className="bg-white p-8 rounded-xl shadow-2xl">
            <h3 className="text-2xl font-bold text-slate-900 mb-2 text-center">Get Instant Access</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sr-only">Full Name</label>
                <div className="relative"><SafeIcon icon={FiUser} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" /><input type="text" name="name" required value={formData.name} onChange={handleInputChange} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500" placeholder="Full Name" /></div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sr-only">Business Email</label>
                <div className="relative"><SafeIcon icon={FiMail} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" /><input type="email" name="email" required value={formData.email} onChange={handleInputChange} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500" placeholder="Business Email" /></div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sr-only">Company Name</label>
                <div className="relative"><SafeIcon icon={FiBriefcase} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" /><input type="text" name="company" required value={formData.company} onChange={handleInputChange} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500" placeholder="Company Name" /></div>
              </div>
              <motion.button type="submit" whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-4 rounded-lg transition-colors flex items-center justify-center"><SafeIcon icon={FiDownload} className="mr-2" />Download Now</motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhitepaperSection;